import { ApiBusinessUnit, ApiClient } from '../../../api/_legacy/generated-api'
import { BusinessUnit, Client } from '../types'

// TODO: Remove this as it's not needed any more
export function mapToBusinessUnit(businessUnit: ApiBusinessUnit): BusinessUnit {
  return {
    ...businessUnit
  }
}

export function mapToClient(client: ApiClient): Client {
  return {
    ...client,
    isExpanded: false,
    businessUnits: client.businessUnits.map(mapToBusinessUnit)
  }
}
